import type { ThemeOptions } from '@mui/material'

import { MuiAlert } from './alert'
import { MuiAutocomplete } from './autocomplete'
import { MuiButton, MuiButtonBase, MuiIconButton } from './buttons'
import { MuiCheckbox } from './checkbox'
import { MuiChip } from './chip'
import { MuiMenu, MuiMenuItem } from './dropdown'
import { MuiFormHelperText, MuiInputAdornment, MuiInputLabel, MuiOutlinedInput } from './inputs'
import { MuiSwitch } from './switch'
import { MuiPagination, MuiPaginationItem, MuiTableCell, MuiTableContainer, MuiTableRow, MuiTableSortLabel } from './table'
import { MuiToggleButton, MuiToggleButtonGroup } from './toggleButton'
import { MuiTooltip } from './tooltip'

/**
 * The Redesigned components overrides.
 */

export const components: ThemeOptions['components'] = {
    MuiAlert,
    MuiAutocomplete,
    MuiButton,
    MuiButtonBase,
    MuiCheckbox,
    MuiChip,
    MuiIconButton,
    MuiInputAdornment,
    MuiInputLabel,
    MuiFormHelperText,
    MuiMenu,
    MuiMenuItem,
    MuiOutlinedInput,
    MuiPagination,
    MuiPaginationItem,
    MuiSwitch,
    MuiTableCell,
    MuiTableContainer,
    MuiTableRow,
    MuiTableSortLabel,
    MuiToggleButton,
    MuiToggleButtonGroup,
    MuiTooltip,
}
